import { RecruitingInterviewData } from '../../../../../store/exam/types';
import { toTime } from '../../../../../utils/generalHelpers';
import Button from '../../../../../components/Button';
import styles from './style.module.scss';
import Webcam from 'react-webcam';

interface Props {
    counter: number;
    webcamRef: any;
    totalQuestions: number;
    currentQuestion: number;
    isFetchingData: boolean;
    nextQuestion: () => void;
    interviewData: RecruitingInterviewData | null;
};

export default function Interview(props: Props) {
    const {
        counter,
        webcamRef,
        nextQuestion,
        interviewData,
        totalQuestions,
        isFetchingData,
        currentQuestion,
    } = props;

    const { minutes, seconds } = toTime(counter);
    const { minutes: captureMin, seconds: captureSec } = toTime(300 - counter);

    return (
        <div className={styles.container}>
            <div className={styles.question_box}>
                <div className={styles.header}>
                    <div className={styles.header_question_count}>
                        {`${currentQuestion} / ${totalQuestions}`}
                    </div>
                </div>
                <span className={styles.question_box_text}>
                    {currentQuestion}. {interviewData?.question.question}
                </span>
                <div className={styles.extra}>
                    <div className={styles.extra_countdown}>
                        <div className={styles.extra_countdown_numb}>
                            <span>{minutes}</span>
                            <span>Minutes</span>
                        </div>
                        <span className={styles.extra_countdown_divider}>:</span>
                        <div className={styles.extra_countdown_numb}>
                            <span data-is-color-primary="true">{seconds}</span>
                            <span>Seconds</span>
                        </div>
                    </div>
                    <Button
                        type='Primary'
                        text='Next question'
                        onClick={nextQuestion}
                        loading={isFetchingData}
                        className={styles.extra_btn}
                    />
                </div>
            </div>
            <div className={styles.stream_box}>
                <div className={styles.stream_box_cam}>
                    <Webcam
                        audio
                        muted
                        ref={webcamRef}
                        disablePictureInPicture
                    />
                </div>
                <div className={styles.stream_box_extra}>
                    <div className={styles.stream_box_extra_counter}>
                        <span className={styles.stream_box_extra_counter_live}></span>
                        <span className={styles.stream_box_extra_counter_stopwatch}>{`0${captureMin}:${captureSec}`}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
